var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn text-cursor m-l-16",on:{"click":_vm.goPage}},[_c('i',{staticClass:"iconfont icon--_fenxi"}),_vm._v(" 采购单位分析 ")])}
var staticRenderFns = []

export { render, staticRenderFns }